import { Link } from 'react-router-dom';
import type { Actor } from '@/mocks/actors';

interface ActorCardProps {
  actor: Actor;
}

export default function ActorCard({ actor }: ActorCardProps) {
  return (
    <Link to={`/actor/${actor.id}`} className="group block cursor-pointer">
      <div className="relative w-full aspect-[3/4] overflow-hidden rounded-lg bg-background-800">
        <img
          src={actor.avatar}
          alt={`${actor.name} 演员照`}
          title={`${actor.name} - 成人短剧演员资料`}
          className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-950 via-background-950/10 to-transparent" />
        <div className="absolute inset-x-0 bottom-0 p-3">
          <h3 className="text-base font-semibold text-foreground-50">{actor.name}</h3>
          <p className="mt-0.5 text-xs text-foreground-400">{actor.region}</p>
        </div>
      </div>
      <div className="mt-2.5 flex flex-wrap gap-1.5">
        {actor.tags.slice(0, 2).map((tag) => (
          <span
            key={tag}
            className="rounded-full bg-secondary-900/60 px-2.5 py-0.5 text-[11px] text-secondary-200"
          >
            {tag}
          </span>
        ))}
      </div>
    </Link>
  );
}